import { MetaDispatcher as SourceMetaDispatcher } from 'SourceStore/Meta/Meta.dispatcher';

export class MetaDispatcher extends SourceMetaDispatcher {
    _getProductMeta(product) {
        const {
            meta_title,
            meta_keyword,
            meta_description,
            canonical_url: source_canonical_url,
            media_gallery_entries
        } = product;

        const og_image = media_gallery_entries?.find(entry =>
            entry.media_type === 'image' && entry.types.length > 0
        )?.base.url;
        console.log('product ', product);
        console.log('media_gallery_entries ', media_gallery_entries);
        console.log('og_image ', og_image);
        const canonical_url = source_canonical_url ? `${window?.location?.origin}/${source_canonical_url}` : null;

        return {
            description: meta_description,
            keywords: meta_keyword,
            title: meta_title,
            canonical_url,
            og_type: 'product',
            og_image
        };
    }

    _getCategoryMeta(category) {
        const {
            description,
            name,
            canonical_url: source_canonical_url,
            meta_title,
            meta_keyword,
            meta_description,
            meta_robots,
            image
        } = category;

        const canonical_url = source_canonical_url ? `${source_canonical_url}` : null;
        let robots = meta_robots || 'index, follow';

        if (typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search);
            const hasSortParam = urlParams.has('sortKey');
            const hasPageParam = urlParams.has('page');

            // Check for custom filters and count active filters
            const customFilters = urlParams.get('customFilters');
            let numberOfActiveFilters = 0;

            if (customFilters) {
                const filterGroups = customFilters.split(';');
                numberOfActiveFilters = filterGroups.reduce((total, group) => {
                    const [filterName, filterValues] = group.split(':');
                    if (filterValues) {
                        const valuesArray = filterValues.split(',');
                        return total + valuesArray.length;
                    }
                    return total;
                }, 0);
            }

            // Update robots tag based on filter, pagination conditions or custom filters
            if (hasPageParam || numberOfActiveFilters >= 1) {
                robots = 'noindex, follow';
            }

            if (hasSortParam) {
                robots = 'noindex, nofollow';
            }
        }

        return {
            description: meta_description || description,
            title: meta_title || name,
            keywords: meta_keyword,
            canonical_url,
            robots,
            og_image: image,
        };
    }
}

export default new MetaDispatcher();
